import { useFetch } from '@/hooks/useFetch';
import type { ErrorResponse } from '@/types/apiTypes';
import { useMutation } from '@tanstack/react-query';

export const useDeleteClientProfileImageMutation = () => {
  const { doFetch: deleteClientProfileImage } = useFetch<void, void>();
  return useMutation<void, ErrorResponse<unknown>, { clientId: number }>({
    mutationFn: ({ clientId }: { clientId: number }) => deleteClientProfileImage(`/api/client-details/${clientId}/profile-picture`, { method: 'DELETE' }),
  });
};